import React, {useEffect, useMemo} from "react";
import {useTranslation} from "react-i18next";
import {Block, BoolSelect, FormGroup, Yup, useForm} from "../components";
import {Col, Form} from "react-bootstrap";

function UserForm({formInitProps = {validationSchema: {}, initialValues: {}}, canSelectRole, ...props}) {
  const { t } = useTranslation();

  const getChildWithProp = (prop) => React.Children.toArray(props.children).filter((child, i) => {
    return child.props[prop];
  })[0];

  const ChildCompanySelect = useMemo(() => getChildWithProp("company"), [props.children])
  const ChildRoleSelect = useMemo(() => getChildWithProp("role"), [props.children])

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required(),
    lastName: Yup.string().required(),
    email: Yup.string().email().required(),
    phoneNumber: Yup.string(),
    subscribedToSdkVersionNewsletter: Yup.boolean(),
    roles: ChildRoleSelect ? Yup.array().min(1) : Yup.array().nullable(),
    ...formInitProps.validationSchema
  })

  const {formData, getInputProps, formProps} = useForm({
    defaultObject: props.user,
    validationSchema: validationSchema,
    initialValues: {
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      roles: ChildRoleSelect ? [] : null,
      subscribedToSdkVersionNewsletter: false,
      ...formInitProps.initialValues
    },
    setSubmitButtonProps: props.setSubmitButtonProps,
    onSubmit: props.handleSubmit
  })

  return (
    <Form {...formProps}>
      <Block>
        <Form.Row>
          <FormGroup as={Col} md={12} lg={6} input="text" label={t("users.firstName")} {...getInputProps("firstName")}/>
          <FormGroup as={Col} md={12} lg={6} input="text" label={t("users.lastName")} {...getInputProps("lastName")}/>
        </Form.Row>
        <Form.Row>
          <FormGroup as={Col} md={12} lg={6} input="email" label={t("users.email")} {...getInputProps("email")}/>
          <FormGroup as={Col} md={12} lg={6} input="email" label={t("users.phoneNumber")} {...getInputProps("phoneNumber")}/>
        </Form.Row>
        <Form.Row>
          {ChildCompanySelect && <FormGroup as={Col} md={12} lg={6} label={t("users.company")} placeholder={t("pleaseSelect")} {...getInputProps("company")}>
            {ChildCompanySelect}
          </FormGroup>}
          {ChildRoleSelect && <FormGroup as={Col} md={12} lg={6} label={t("users.role")} placeholder={t("pleaseSelect")} {...getInputProps("roles")}>
            {ChildRoleSelect}
          </FormGroup>}
        </Form.Row>
        <Form.Row>
          <FormGroup as={Col} md={12} lg={6} label={t("users.subscribedToSdkVersionNewsletter")} {...getInputProps("subscribedToSdkVersionNewsletter")}>
            <BoolSelect/>
          </FormGroup>
        </Form.Row>
      </Block>
    </Form>
  )
}

export default UserForm
